import Col from "react-bootstrap/Col";
import { Form, Row } from "antd";
import UIElement from "../../UIElement";
import Styled from "styled-components";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import moment from "moment";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export const FormWrap = Styled.div`
.btn{
    border: none;
    padding: 10px 30px;
    width: 100%;
}
.center{  
    display: flex;
    justify-content: center;
    align-items: middle;
}
.end{
    display: flex;
    justify-content: end;
}
.start{
    display: flex;
    justify-content: start;
}
`;

const GridBuilder = forwardRef((props, ref) => {
  const [form] = Form.useForm();

  const {
    formStructureJson,
    handleChange,
    formSubmit,
    loading,
    handleClick,
    handleForgotPassword,
    domainStatus,
    urlLoader,
    initialValues = {},
    handleSelectChange,
    handleBack,
    isModalOpen = false,
    uploadFile,
    setStep,
    setData
  } = props;

  const colStyle = {};

  // Expose methods using `useImperativeHandle`
  // useImperativeHandle(ref, () => ({
  //   submit: () => {
  //     form.submit(); // Triggers form submission
  //   },
  //   validate: async () => {
  //     try {
  //       const values = await form.validateFields(); // Validates all fields
  //       return { valid: true, values };
  //     } catch (error) {
  //       return { valid: false, error };
  //     }
  //   },
  // }));

  // Set form initial values on mount or when `initialValues` change

  const systemData = Object.keys(initialValues.products || {}).reduce(
    (acc, key) => {
      const keyMapping = {
        tymeplusHrStatus: "hr",
        tymeplusPayStatus: "pay",
      };
      if (initialValues.products[key] === true && keyMapping[key]) {
        acc[keyMapping[key]] = true;
      }
      return acc;
    },
    {}
  );
  
  const system = Object.keys(systemData);

  const [formatedValues, setFormatedValues] = useState(() => { 
    if (initialValues?.products && Object.keys(initialValues.products).length > 0) {
      return {
        ...initialValues,
        subscription_start_date:
          initialValues?.subscription_start_date &&
          typeof initialValues.subscription_start_date === "string" &&
          dayjs(initialValues.subscription_start_date, "DD-MM-YYYY").isValid()
            ? dayjs(initialValues.subscription_start_date, "DD-MM-YYYY")
            : null,
        system: system,
      };
    }
    return {};
  });
  

  useEffect(() => {
    if (
      initialValues?.products &&
      Object.keys(initialValues.products).length > 0
    ) {
      const selectedSystems = Object.keys(initialValues.products).filter(
        (key) => initialValues.products[key]
      );
  
      const updatedValues = {
        ...initialValues,
        subscription_start_date:
          initialValues?.subscription_start_date &&
          dayjs(initialValues.subscription_start_date, "DD-MM-YYYY").isValid()
            ? dayjs(initialValues.subscription_start_date, "DD-MM-YYYY")
            : form.getFieldValue("subscription_start_date") || null, // Keep selected date
        system: system,
      };
      // setData((prev) => ({
      //   ...prev,
      //   system: system
      // }));
      setFormatedValues(updatedValues);
      form.setFieldsValue(updatedValues);
    } else {
      form.setFieldsValue(initialValues);
    }
  }, [initialValues, isModalOpen]);

  useEffect(() => {
    form.resetFields();
  }, [isModalOpen]);

  return (
    <Form
      form={form}
      onFinish={()=>formSubmit()}
      className="email_refer help_form"
      initialValues={
        Object.keys(formatedValues).length > 0 ? formatedValues : initialValues
      }
      ref={ref}
      autoComplete="off"
    >
      <h6>{formStructureJson?.title}</h6>
      {formStructureJson.pages[0]?.fields.map((row, rowIndex) => (
        <Row gutter={12} key={rowIndex}>
          {row?.map((field, colIndex) => {
            return (
              <>
                {field?.length > 1 ? (
                  <Col
                    sm={row?.length === 2 ? 6 : row?.length === 3 ? 4 : 3}
                    className={row?.length === 1 && "action_form_button_style"}
                  >
                    <Row>
                      {field?.map((data) => (
                        <Col
                          key={data.id}
                          style={colStyle}
                          sm={
                            formStructureJson.pages[0]?.colSpan[rowIndex][
                              colIndex
                            ]
                          }
                        >
                          <FormWrap>
                            <UIElement
                              label={data?.label}
                              type={data?.type}
                              options={data?.options}
                              name={data?.name}
                              multipleSelect={field?.multipleSelect || ""}
                              position={field?.position}
                              background={field?.background}
                              textColor={field?.textColor}
                              disabled={field?.disabled}
                              row={field?.row}
                              Placeholder={field?.Placeholder}
                              picker={field?.picker}
                              maxLength={field?.maxLength}
                              required={field?.required}
                              value={field?.value}
                              // value={form.getFieldValue(data?.name)}
                              CountNumber={field?.CountNumber}
                              content={field?.content}
                              handleChange={handleChange}
                              handleSelectChange={handleSelectChange}
                              readOnly={field?.readOnly}
                              event={field?.event}
                              loading={loading}
                              handleClick={() => handleClick()}
                              handleBack={() => handleBack()}
                              onInput={field.onInput}
                              className={data?.position}
                              validationRules={data?.validationRules}
                              handleForgotPassword={handleForgotPassword}
                              onKeyDown={data?.onKeyDown}
                              suffixUrl={data?.suffixUrl}
                              domainStatus={domainStatus}
                              urlLoader={urlLoader}
                              link={data?.link}
                              form={form}
                              buttons={field?.buttons}
                              mode={field?.mode}
                              uploadFile={uploadFile}
                            />
                          </FormWrap>
                        </Col>
                      ))}
                    </Row>
                  </Col>
                ) : (
                  <Col
                    key={field.id}
                    style={colStyle}
                    sm={formStructureJson.pages[0]?.colSpan[rowIndex]}
                  >
                    <FormWrap>
                      <UIElement
                        label={field?.label}
                        type={field?.type}
                        options={field?.options}
                        name={field?.name}
                        multipleSelect={field?.multipleSelect || ""}
                        position={field?.position}
                        background={field?.background}
                        textColor={field?.textColor}
                        disabled={field?.disabled}
                        row={field?.row}
                        Placeholder={field?.Placeholder}
                        picker={field?.picker}
                        maxLength={field?.maxLength}
                        required={field?.required}
                        value={field?.value}
                        // value={form.getFieldValue(field?.name)}
                        content={field?.content}
                        handleChange={handleChange}
                        handleSelectChange={handleSelectChange}
                        readOnly={field?.readOnly}
                        event={field?.event}
                        loading={loading}
                        handleClick={() => handleClick()}
                        handleBack={() => handleBack()}
                        className={field?.position}
                        validationRules={field?.validationRules}
                        handleForgotPassword={handleForgotPassword}
                        onKeyDown={field?.onKeyDown}
                        suffixUrl={field?.suffixUrl}
                        domainStatus={domainStatus}
                        urlLoader={urlLoader}
                        link={field?.link}
                        form={form}
                        mode={field?.mode}
                        buttons={field?.buttons}
                        onInput={field.onInput}
                        uploadFile={uploadFile}
                      />
                    </FormWrap>
                  </Col>
                )}
              </>
            );
          })}
        </Row>
      ))}
    </Form>
  );
});

export default GridBuilder;
